// import React from 'react';
// import { Box, Typography, Paper, Avatar, Button, Grid } from '@mui/material';

// interface MenuCardProps {
// 	data: any;
// 	handleOpen: (defaultMenuId: string, eventID: string) => void;
// }

// const MenuCard: React.FC<MenuCardProps> = ({ data, handleOpen }) => (
// 	<div>
// 		<Box
// 			sx={{
// 				borderTopLeftRadius: 5,
// 				borderTopRightRadius: 5,
// 				backgroundColor: 'primary.main',
// 				pt: 3,
// 				pb: 2,
// 			}}
// 		>
// 			<Typography variant="h6" align="center" fontWeight="bold" color="#fff">
// 				{data.name}
// 			</Typography>
// 			<Typography variant="h5" align="center" fontWeight={600} gutterBottom color="#FFFFFF">
// 				₹{data.price.toLocaleString()}
// 			</Typography>
// 			<Typography
// 				variant="subtitle2"
// 				sx={{ color: '#FFBDC8', fontSize: '13px' }}
// 				align="center"
// 				fontWeight={600}
// 			>
// 				{data.description}
// 			</Typography>
// 		</Box>
// 		<Paper
// 			elevation={3}
// 			sx={{
// 				borderRadius: 0,
// 				borderBottomLeftRadius: 5,
// 				borderBottomRightRadius: 5,
// 				p: 3,
// 				mb: 4,
// 			}}
// 		>
// 			{data.menuItems?.map((menuItem: any, i: number) => (
// 				<Box key={i} sx={{ mb: 2 }}>
// 					<Typography variant="subtitle1" fontWeight="bold" color="error" gutterBottom>
// 						{menuItem.menuType} For {menuItem.numberOfPersons} Person
// 					</Typography>

// 					{menuItem.items?.map((item: string, j: number) => (
// 						<Box
// 							key={j}
// 							display="flex"
// 							// alignItems="flex-start"
// 							alignItems="center"
// 							justifyContent={'flex-start'}
// 							gap={1}
// 							mb={0.5}
// 						>
// 							<Avatar
// 								src="/assets/points-image.svg"
// 								alt="bullet"
// 								sx={{ width: '19px', height: '12px' }}
// 							/>
// 							<Typography variant="body2">{item}</Typography>
// 						</Box>
// 					))}
// 				</Box>
// 			))}
// 			<Box sx={{ mb: 2 }}>
// 				<Typography variant="subtitle1" fontWeight="bold" color="error" gutterBottom>
// 					Complementary
// 				</Typography>
// 				{/* <Box display="flex" alignItems="flex-start" gap={1} mb={0.5}>
// 					<Avatar
// 						src="/assets/points-image.svg"
// 						alt="bullet"
// 						sx={{ width: 22, height: 15, marginTop: '5px' }}
// 					/>
// 					<Typography variant="body2">{data.complementary}</Typography>
// 				</Box> */}
// 				<Box display="flex" flexDirection="column" gap={0.5} mb={0.5}>
// 					{data.complementary.map(
// 						(comp: { item: string; quantity: number; _id: string }, index: number) => (
// 							<Box
// 								key={comp._id || index}
// 								display="flex"
// 								// alignItems="flex-start"
// 								alignItems="center"
// 								justifyContent={'flex-start'}
// 								gap={1}
// 							>
// 								<Avatar
// 									src="/assets/points-image.svg"
// 									alt="bullet"
// 									// sx={{ width: 22, height: 15, marginTop: '5px' }}
// 									sx={{ width: '19px', height: '12px' }}
// 								/>
// 								<Typography variant="body2">
// 									{comp.item} - {comp.quantity}
// 								</Typography>
// 							</Box>
// 						)
// 					)}
// 				</Box>
// 			</Box>
// 			{/* <Box
// 				display="flex"
// 				justifyContent="space-around"
// 				alignItems="center"
// 				sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
// 			>
// 				{data.menuImage?.map((menuImage: any, i: number) => (
// 					<Box key={i}>
// 						<Avatar
// 							src={menuImage}
// 							style={{ borderRadius: 2, width: '85px', height: '85px' }}
// 							variant="square"
// 						/>
// 					</Box>
// 				))}
// 			</Box> */}
// 			<Grid container spacing={2}>
// 				{data.menuImage?.map((menuImage: any, i: number) => (
// 					<Grid size={{ xs: 12, sm: 3, md: 2, lg: 2 }} key={i}>
// 						<Box display="flex" justifyContent="center">
// 							<Avatar
// 								src={menuImage}
// 								style={{ borderRadius: 2, width: '85px', height: '85px' }}
// 								variant="square"
// 							/>
// 						</Box>
// 					</Grid>
// 				))}
// 			</Grid>
// 			<Box className="mt-4 d-flex justify-content-center align-item-center">
// 				<Button
// 					color="primary"
// 					variant="contained"
// 					onClick={() => handleOpen(data._id, data?.eventType)}
// 				>
// 					Select this package
// 				</Button>
// 			</Box>
// 		</Paper>
// 	</div>
// );

// export default MenuCard;
// =======================================================================================================================
// =======================================================================================================================
// =======================================================================================================================
// =======================================================================================================================
// =======================================================================================================================
// =======================================================================================================================
// =======================================================================================================================
// =======================================================================================================================
// =======================================================================================================================
// =======================================================================================================================
// =======================================================================================================================
// =======================================================================================================================
// import React from 'react';
// // import { Box, Typography, Paper, Avatar, Button, Grid } from '@mui/material';

// interface MenuCardProps {
// 	data: any;
// 	handleOpen: (defaultMenuId: string, eventID: string) => void;
// }

// const MenuCard: React.FC<MenuCardProps> = ({ data, handleOpen }) => (
// 	<div>
// 		{/* <Box
// 			sx={{
// 				borderTopLeftRadius: 5,
// 				borderTopRightRadius: 5,
// 				backgroundColor: 'primary.main',
// 				pt: 3,
// 				pb: 2,
// 			}}
// 		>
// 			<Typography variant="h6" align="center" fontWeight="bold" color="#fff">
// 				{data.name}
// 			</Typography>
// 			<Typography variant="h5" align="center" fontWeight={600} gutterBottom color="#FFFFFF">
// 				₹{data.price.toLocaleString()}
// 			</Typography>
// 			<Typography
// 				variant="subtitle2"
// 				sx={{ color: '#FFBDC8', fontSize: '13px' }}
// 				align="center"
// 				fontWeight={600}
// 			>
// 				{data.description}
// 			</Typography>
// 		</Box>
// 		<Paper
// 			elevation={3}
// 			sx={{
// 				borderRadius: 0,
// 				borderBottomLeftRadius: 5,
// 				borderBottomRightRadius: 5,
// 				p: 3,
// 				mb: 4,
// 			}}
// 		>
// 			{data.menuItems?.map((menuItem: any, i: number) => (
// 				<Box key={i} sx={{ mb: 2 }}>
// 					<Typography variant="subtitle1" fontWeight="bold" color="error" gutterBottom>
// 						{menuItem.menuType} For {menuItem.numberOfPersons} Person
// 					</Typography>

// 					{menuItem.items?.map((item: string, j: number) => (
// 						<Box
// 							key={j}
// 							display="flex"
// 							// alignItems="flex-start"
// 							alignItems="center"
// 							justifyContent={'flex-start'}
// 							gap={1}
// 							mb={0.5}
// 						>
// 							<Avatar
// 								src="/assets/points-image.svg"
// 								alt="bullet"
// 								sx={{ width: '19px', height: '12px' }}
// 							/>
// 							<Typography variant="body2">{item}</Typography>
// 						</Box>
// 					))}
// 				</Box>
// 			))}
// 			<Box sx={{ mb: 2 }}>
// 				<Typography variant="subtitle1" fontWeight="bold" color="error" gutterBottom>
// 					Complementary
// 				</Typography>

// 				<Box display="flex" flexDirection="column" gap={0.5} mb={0.5}>
// 					{data.complementary.map(
// 						(comp: { item: string; quantity: number; _id: string }, index: number) => (
// 							<Box
// 								key={comp._id || index}
// 								display="flex"
// 								// alignItems="flex-start"
// 								alignItems="center"
// 								justifyContent={'flex-start'}
// 								gap={1}
// 							>
// 								<Avatar
// 									src="/assets/points-image.svg"
// 									alt="bullet"
// 									// sx={{ width: 22, height: 15, marginTop: '5px' }}
// 									sx={{ width: '19px', height: '12px' }}
// 								/>
// 								<Typography variant="body2">
// 									{comp.item} - {comp.quantity}
// 								</Typography>
// 							</Box>
// 						)
// 					)}
// 				</Box>
// 			</Box>

// 			<Grid container spacing={2}>
// 				{data.menuImage?.map((menuImage: any, i: number) => (
// 					<Grid size={{ xs: 12, sm: 3, md: 2, lg: 2 }} key={i}>
// 						<Box display="flex" justifyContent="center">
// 							<Avatar
// 								src={menuImage}
// 								style={{ borderRadius: 2, width: '85px', height: '85px' }}
// 								variant="square"
// 							/>
// 						</Box>
// 					</Grid>
// 				))}
// 			</Grid>
// 			<Box className="mt-4 d-flex justify-content-center align-item-center">
// 				<Button
// 					color="primary"
// 					variant="contained"
// 					onClick={() => handleOpen(data._id, data?.eventType)}
// 				>
// 					Select this package
// 				</Button>
// 			</Box>
// 		</Paper> */}
// 		<div className="card">
// 			<div className="card__shine"></div>
// 			<div className="plan-card">
// 				{/* <div className="card__glow"></div> */}
// 				<h2>
// 					{/* Grand Muhurtham Menu (கிராண்ட் முகூர்த்த மெனு) */}
// 					{data.name}
// 					<span>
// 						{/* A rich and flavorful collection of South Indian delicacies, served from morning
// 					tiffin to grand dinner. The menu celebrates heritage recipes, festive sweets,
// 					and mouthwatering varieties to delight every guest with love and tradition. */}
// 						{data.description}
// 					</span>
// 				</h2>
// 				<div className="etiquet-price">
// 					{/* <p>299,000</p> */}
// 					<p>{data.price.toLocaleString()}</p>
// 					<div></div>
// 				</div>
// 				<div className="button-get-plan">
// 					<a href="#">
// 						<svg
// 							xmlns="http://www.w3.org/2000/svg"
// 							viewBox="0 0 512 512"
// 							className="svg-rocket"
// 						>
// 							<path d="M156.6 384.9L125.7 353.1C117.2 345.5 114.2 333.1 117.1 321.8C120.1 312.9 124.1 301.3 129.8 288H24C15.38 288 7.414 283.4 3.146 275.9C-1.123 268.4-1.042 259.2 3.357 251.8L55.83 163.3C68.79 141.4 92.33 127.1 117.8 127.1H200C202.4 124 204.8 120.3 207.2 116.7C289.1-4.07 411.1-8.142 483.9 5.275C495.6 7.414 504.6 16.43 506.7 28.06C520.1 100.9 516.1 222.9 395.3 304.8C391.8 307.2 387.1 309.6 384 311.1V394.2C384 419.7 370.6 443.2 348.7 456.2L260.2 508.6C252.8 513 243.6 513.1 236.1 508.9C228.6 504.6 224 496.6 224 488V380.8C209.9 385.6 197.6 389.7 188.3 392.7C177.1 396.3 164.9 393.2 156.6 384.9V384.9zM384 167.1C406.1 167.1 424 150.1 424 127.1C424 105.9 406.1 87.1 384 87.1C361.9 87.1 344 105.9 344 127.1C344 150.1 361.9 167.1 384 167.1z"></path>
// 						</svg>
// 						<span onClick={() => handleOpen(data._id, data?.eventType)}>
// 							SELECT THIS PACKAGE
// 						</span>
// 					</a>
// 				</div>
// 			</div>
// 		</div>
// 	</div>
// );

// export default MenuCard;
// ================================================================
// ================================================================
// ================================================================
// ================================================================
// ================================================================
// ================================================================
// ================================================================
// ================================================================
// ================================================================
// ================================================================
// ================================================================
// import React from 'react';

// interface MenuCardProps {
// 	data: any;
// 	handleOpen: (defaultMenuId: string, eventID: string) => void;
// }

// const MenuCard: React.FC<MenuCardProps> = ({ data, handleOpen }) => (
// 	<div>
// 		<div className="card">
// 			<div className="card__shine"></div>
// 			<div className="plan-card">
// 				<h2>
// 					{data.name}
// 					<span>{data.description}</span>
// 				</h2>
// 				<div className="etiquet-price">
// 					<p>{data.price.toLocaleString()}</p>
// 					<div></div>
// 				</div>
// 				<div className="button-get-plan">
// 					<a href="#">
// 						<svg
// 							xmlns="http://www.w3.org/2000/svg"
// 							viewBox="0 0 512 512"
// 							className="svg-rocket"
// 						>
// 							<path d="M156.6 384.9L125.7 353.1C117.2 345.5 114.2 333.1 117.1 321.8C120.1 312.9 124.1 301.3 129.8 288H24C15.38 288 7.414 283.4 3.146 275.9C-1.123 268.4-1.042 259.2 3.357 251.8L55.83 163.3C68.79 141.4 92.33 127.1 117.8 127.1H200C202.4 124 204.8 120.3 207.2 116.7C289.1-4.07 411.1-8.142 483.9 5.275C495.6 7.414 504.6 16.43 506.7 28.06C520.1 100.9 516.1 222.9 395.3 304.8C391.8 307.2 387.1 309.6 384 311.1V394.2C384 419.7 370.6 443.2 348.7 456.2L260.2 508.6C252.8 513 243.6 513.1 236.1 508.9C228.6 504.6 224 496.6 224 488V380.8C209.9 385.6 197.6 389.7 188.3 392.7C177.1 396.3 164.9 393.2 156.6 384.9V384.9zM384 167.1C406.1 167.1 424 150.1 424 127.1C424 105.9 406.1 87.1 384 87.1C361.9 87.1 344 105.9 344 127.1C344 150.1 361.9 167.1 384 167.1z"></path>
// 						</svg>
// 						<span onClick={() => handleOpen(data._id, data?.eventType)}>
// 							SELECT THIS PACKAGE
// 						</span>
// 					</a>
// 				</div>
// 			</div>
// 		</div>
// 	</div>
// );

// export default MenuCard;
// ===========================================================================================
// ===========================================================================================
// ===========================================================================================
// ===========================================================================================
// ===========================================================================================
// ===========================================================================================
// ===========================================================================================
// ===========================================================================================
// ===========================================================================================
// ===========================================================================================
import React from 'react';
import Tooltip from '@mui/material/Tooltip';

interface MenuCardProps {
	data: any;
	handleOpen: (defaultMenuId: string, eventID: string) => void;
}

const MenuCard: React.FC<MenuCardProps> = ({ data, handleOpen }) => (
	<div>
		<div className="card">
			<div className="card__shine"></div>
			<div className="plan-card">
				<Tooltip arrow title={data.name} placement="right-end">
					<h2>{data.name}</h2>
				</Tooltip>
				<Tooltip arrow title={data.description} placement="right-end">
					<div className="description">{data.description}</div>
				</Tooltip>
				<div className="etiquet-price">
					<p>{data?.price?.toLocaleString()}</p>
					<div></div>
				</div>
				<div className="button-get-plan">
					<a href="#">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 512 512"
							className="svg-rocket"
						>
							<path d="M156.6 384.9L125.7 353.1C117.2 345.5 114.2 333.1 117.1 321.8C120.1 312.9 124.1 301.3 129.8 288H24C15.38 288 7.414 283.4 3.146 275.9C-1.123 268.4-1.042 259.2 3.357 251.8L55.83 163.3C68.79 141.4 92.33 127.1 117.8 127.1H200C202.4 124 204.8 120.3 207.2 116.7C289.1-4.07 411.1-8.142 483.9 5.275C495.6 7.414 504.6 16.43 506.7 28.06C520.1 100.9 516.1 222.9 395.3 304.8C391.8 307.2 387.1 309.6 384 311.1V394.2C384 419.7 370.6 443.2 348.7 456.2L260.2 508.6C252.8 513 243.6 513.1 236.1 508.9C228.6 504.6 224 496.6 224 488V380.8C209.9 385.6 197.6 389.7 188.3 392.7C177.1 396.3 164.9 393.2 156.6 384.9V384.9zM384 167.1C406.1 167.1 424 150.1 424 127.1C424 105.9 406.1 87.1 384 87.1C361.9 87.1 344 105.9 344 127.1C344 150.1 361.9 167.1 384 167.1z"></path>
						</svg>
						<span onClick={() => handleOpen(data._id, data?.eventType)}>
							SELECT THIS PACKAGE
						</span>
					</a>
				</div>
			</div>
		</div>
	</div>
);

export default MenuCard;
